// extracted by mini-css-extract-plugin
export default {"addToCartControl":"l2-z","giftCard":"m2-z","btnContainer":"n2-z","cartButton":"o2-z","disabled":"p2-z"};